"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidRegNr = exports.regNrRegex = void 0;
exports.regNrRegex = /[A-Z]{3}[0-9]{2}[0-9A-Z]/ig;
/**
 * Test if a string is a valid swedish registration number.
 *
 * @param val
 */
function isValidRegNr(val) {
    return exports.regNrRegex.test(val);
}
exports.isValidRegNr = isValidRegNr;
//# sourceMappingURL=regNr.js.map